import type { FaireProductEntity } from "../../entity_types/product";

export const p_f2dfpfud7a: FaireProductEntity = {
  token: "p_f2dfpfud7a",
  type: "product",
  name: "Viverano Branded Baby Garment Eco Hangers (25 pack)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1d963d9d65f062f3b4e133e2f356c8fb9d556da408995652a11106a1570d1912.png",
  galleryImageUrls: [],
  priceDollars: 15,
  description:
    'Viverano Branded Recycled Cardboard Baby Garment Hangers\n\nDisplay your Viverano baby garments beautifully with our branded eco-friendly hangers, thoughtfully made from recycled cardboard material. Lightweight, sturdy, and perfectly sized for infant and toddler apparel, these hangers are ideal for boutique merchandising, gift presentation, photoshoots, and retail displays.\n\nA simple way to elevate your store presentation while staying true to sustainable values — because even the hanger should tell the right story.\n\nDetails:\n\nMade from recycled cardboard material\nSustainable and eco-friendly\nViverano Organics branded design\nPerfect for hanging and displaying baby garments\nGreat for boutique merchandising and brand presentation\nSize: 9.5" W x 5.75" H\nPack of 25 hangers\nEthically made in India',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T05:03:42.236Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
